import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[modalHost]',
})
export class ModalhostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
